
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infobytes/[slug]",
      function () {
        return require("private-next-pages/infobytes/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infobytes/[slug]"])
      });
    }
  